<template>
    <div v-if="form_data">
        <kt-nav space="md" size="lg" id="kt-nav">

            <form @submit.prevent="changeSheba" id="changeSehba_form">
                <kt-nav-item>
                    <div class="accordion accordion-toggle-arrow" id="changeSheba">
                        <div class="card" style="overflow:inherit">
                            <div class="card-header bg-transparent" id="headingOne">
                                <div class="card-title collapsed" data-toggle="collapse"
                                     data-target="#shebaForm"
                                     aria-controls="shebaForm">
                                    <i class="fa fa-credit-card"></i>
                                    {{ $t('panel.shaparak-requests.change-sheba') }}
                                </div>
                            </div>
                            <div
                                    id="shebaForm"
                                    class="collapse"
                                    aria-labelledby="shebaForm"
                                    data-parent="#changeSheba"
                                    v-if="gateway.status === gatewayStatus.active"
                            >
                                <div class="card-body">
                                    <kt-form-section>
                                        <kt-form-row>
                                            <kt-col xs="12" sm="12" md="6" lg="6">
                                                <kt-form-group>
                                                    <kt-form-label for="shebaNumbers">
                                                        {{ $t('panel.shaparak-requests.sheba_numbers') }}
                                                    </kt-form-label>
                                                    <select
                                                            size="4"
                                                            id="shebaNumbers"
                                                            class="form-control kt-selectpicker"
                                                            v-model="form_data.sheba"
                                                            multiple
                                                            name="shebaNumbers">
                                                        <option
                                                                v-for="sheba_number in sheba_numbers"
                                                                v-bind:key="sheba_number.id"
                                                                :value="sheba_number.id"
                                                        >
                                                            {{ sheba_number.number }}
                                                        </option>
                                                    </select>
                                                </kt-form-group>
                                            </kt-col>
                                        </kt-form-row>
                                    </kt-form-section>
                                    <kt-form-section>
                                        <button class="btn btn-success btn-wide" id="changeSheba_btn">
                                            {{ $t('panel.shaparak-requests.send_to_shaparak') }}
                                        </button>
                                    </kt-form-section>
                                </div>
                            </div>
                        </div>
                    </div>
                </kt-nav-item>
            </form>

            <form @submit.prevent="disableTerminal" id="disableTerminal_form">
                <kt-nav-item>
                    <div class="accordion accordion-toggle-arrow" id="disableTerminal">
                        <div class="card" style="overflow:inherit">
                            <div class="card-header bg-transparent" id="headingTwo">
                                <div class="card-title collapsed" data-toggle="collapse"
                                     data-target="#disableTerminalForm"
                                     aria-controls="disableTerminalForm">
                                    <i class="fa fa-dice-six"></i>
                                    {{ $t('panel.shaparak-requests.terminal-deactivation') }}
                                </div>
                            </div>
                            <div
                                    id="disableTerminalForm"
                                    class="collapse"
                                    aria-labelledby="disableTerminalForm"
                                    data-parent="#disableTerminal"
                                    v-if="gateway.status === gatewayStatus.active"
                            >
                                <div class="card-body">
                                    <kt-form-section>
                                        <button class="btn btn-success btn-wide" id="disableTerminal_btn">
                                            {{ $t('panel.shaparak-requests.send_block_request') }}
                                        </button>
                                    </kt-form-section>
                                </div>
                            </div>
                        </div>
                    </div>
                </kt-nav-item>
            </form>

            <form @submit.prevent="enableTerminal" id="enableTerminal_form">
                <kt-nav-item>
                    <div class="accordion accordion-toggle-arrow" id="enableTerminal">
                        <div class="card" style="overflow:inherit">
                            <div class="card-header bg-transparent" id="headingThree">
                                <div class="card-title collapsed" data-toggle="collapse"
                                     data-target="#enableForm"
                                     aria-controls="enableForm">
                                    <i class="fa fa-dice-six"></i>
                                    {{ $t('panel.shaparak-requests.terminal-activation') }}
                                </div>
                            </div>
                            <div
                                    id="enableForm"
                                    class="collapse"
                                    aria-labelledby="enableForm"
                                    data-parent="#enableTerminal"
                                    v-if="gateway.status === gatewayStatus.blocked"
                            >
                                <div class="card-body">
                                    <kt-form-section>
                                        <button class="btn btn-success btn-wide" id="enableTerminal_btn">
                                            {{ $t('panel.shaparak-requests.send_enable_request') }}
                                        </button>
                                    </kt-form-section>
                                </div>
                            </div>
                        </div>
                    </div>
                </kt-nav-item>
            </form>

            <form @submit.prevent="changeAddress" id="changeAddress_form">
                <kt-nav-item>
                    <div class="accordion accordion-toggle-arrow" id="changeAddress">
                        <div class="card" style="overflow:inherit">
                            <div class="card-header bg-transparent" id="headingFour">
                                <div class="card-title collapsed" data-toggle="collapse"
                                     data-target="#addressForm"
                                     aria-controls="addressForm">
                                    <i class="fa fa-map"></i>
                                    {{ $t('panel.shaparak-requests.change-address') }}
                                </div>
                            </div>
                            <div
                                    id="addressForm"
                                    class="collapse"
                                    aria-labelledby="addressForm"
                                    data-parent="#changeAddress"
                                    v-if="gateway.status === gatewayStatus.active"
                            >
                                <div class="card-body">
                                    <kt-form-section>
                                        <kt-form-row>
                                            <kt-col xs="12" sm="12" md="6" lg="6">
                                                <kt-form-group>
                                                    <kt-form-label for="address">
                                                        {{ $t('panel.shaparak-requests.addresses') }}
                                                    </kt-form-label>
                                                    <select
                                                            size="4"
                                                            id="address"
                                                            class="form-control kt-selectpicker"
                                                            v-model="form_data.address"
                                                            name="address">
                                                        <option
                                                                v-for="address in addresses"
                                                                v-bind:key="address.id"
                                                                :selected="form_data.address === address.id"
                                                                :value="address.id"
                                                        >
                                                            {{ address.address }}
                                                        </option>
                                                    </select>
                                                </kt-form-group>
                                            </kt-col>
                                        </kt-form-row>
                                    </kt-form-section>
                                    <kt-form-section>
                                        <button class="btn btn-success btn-wide" id="changeAddress_btn">
                                            {{ $t('panel.shaparak-requests.send_to_shaparak') }}
                                        </button>
                                    </kt-form-section>
                                </div>
                            </div>
                        </div>
                    </div>
                </kt-nav-item>
            </form>

        </kt-nav>
    </div>
</template>

<script>
    import {mapGetters} from "vuex";
    import $ from "jquery";
    import {KTApp} from '@/plugins/core/app'
    import {KTUtil} from '@/plugins/core/util'
    import {gatewayService} from '@/common/api.service'
    import {gatewayStatus} from '@/constants/gatewayStatus'
    import {i18n} from '@/plugins/i18n'


    export default {
        props: {
            form_data: {
                required: true,
            },
            addresses: {
                required: true,
            },
            sheba_numbers: {
                required: true
            }
        },
        data() {
            return {
                gatewayStatus: {
                    active: gatewayStatus.ACTIVE,
                    blocked: gatewayStatus.BLOCKED
                },
            }
        },
        computed: {
            ...mapGetters('gateway', {
                gateway: 'form_data',
                status: 'status'
            }),
        },
        mounted() {
            $('.kt-selectpicker').selectpicker({
                size: 4,
                liveSearch: true,
                noneResultsText: i18n.t('selectpicker.none_result'),
                selectAllText: i18n.t('selectpicker.select_all'),
                noneSelectedText: i18n.t('selectpicker.nothing_selected')
            })
        },
        methods: {
            changeSheba(e) {
                let form = $('#changeSehba_form')
                let btn = $('#changeSheba_btn')
                let nav = $('#kt-nav')

                KTApp.progress(btn)

                let params = {
                    'sheba_id': this.form_data.sheba,
                    'shop_id': this.$route.params.hashid
                }
                gatewayService.changeSheba(params)
                    .then(response => {
                        this.showMsg(nav, 'success', response.data.message)
                    })
                    .catch(({response}) => {
                        if (response.data) {
                            form.validate().showErrors(response.data.data)
                        }
                        this.showMsg(nav, 'danger', response.data.message)
                    })
                    .finally(() => {
                        KTUtil.scrollTop()
                        KTApp.unprogress(btn)
                    })
            },
            disableTerminal(e) {
                let form = $('#disableTerminal_form')
                let btn = $('#disableTerminal_btn')
                let nav = $('#kt-nav')

                KTApp.progress(btn)

                let params = {
                    'shop_id': this.$route.params.hashid
                }

                gatewayService.disableTerminal(params)
                    .then(response => {
                        this.showMsg(nav, 'success', response.data.message)
                    })
                    .catch(({response}) => {
                        if (response.data) {
                            form.validate().showErrors(response.data.data)
                        }
                        this.showMsg(nav, 'danger', response.data.message)
                    })
                    .finally(() => {
                        KTUtil.scrollTop()
                        KTApp.unprogress(btn)
                    })
            },
            enableTerminal(e) {
                let form = $('#enableTerminal_form')
                let btn = $('#enableTerminal_btn')
                let nav = $('#kt-nav')

                KTApp.progress(btn)

                let params = {
                    'shop_id': this.$route.params.hashid
                }
                gatewayService.enableTerminal(params)
                    .then(response => {
                        this.showMsg(nav, 'success', response.data.message)
                    })
                    .catch(({response}) => {
                        if (response.data) {
                            form.validate().showErrors(response.data.data)
                        }
                        this.showMsg(nav, 'danger', response.data.message)
                    })
                    .finally(() => {
                        KTUtil.scrollTop()
                        KTApp.unprogress(btn)
                    })
            },
            changeAddress(e) {
                let form = $('#changeAddress_form')
                let btn = $('#changeAddress_btn')
                let nav = $('#kt-nav')

                KTApp.progress(btn)

                let params = {
                    'address_id': this.form_data.address,
                    'shop_id': this.$route.params.hashid
                }
                gatewayService.changeAddress(params)
                    .then(response => {
                        this.showMsg(nav, 'success', response.data.message)
                    })
                    .catch(({response}) => {
                        if (response.data) {
                            form.validate().showErrors(response.data.data)
                        }
                        this.showMsg(nav, 'danger', response.data.message)
                    })
                    .finally(() => {
                        KTUtil.scrollTop()
                        KTApp.unprogress(btn)
                    })
            },
        }
    }
</script>

<style>
    .accordion, .card {
        border: none !important;
    }
</style>